import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Pedidos" },
  { label: "Pedidos", icon: "fas fa-shopping-basket", color: "#10b981", bg: "#f0fdf4", href: "/ListadoPedidos", desc: "Pedidos de clientes", perm: "menu_pedidos" },
  // { label: "Listo Surtir", icon: "fas fa-dolly", color: "#3b82f6", bg: "#eff6ff", href: "/ListoSurtir", desc: "Pedidos listos para surtir", perm: "menu_surtidos" },
  // { label: "Surtir", icon: "fas fa-truck-moving", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendienteSurtir", desc: "Pedidos por surtir", perm: "surtidos_create" },  // se surte desde el pedido
  { label: "Notas", icon: "fas fa-file-invoice-dollar", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoSurtidos", desc: "Notas de venta", perm: "menu_surtidos" },
  { label: "Venta Directa", icon: "fas fa-file-invoice-dollar", color: "#0ea5e9", bg: "#f0f9ff", href: "/VentaDirectaCreate", desc: "Venta directa en un paso", perm: "menu_ventas" },
  { type: "section", label: "Devoluciones y cargos" },
  { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#10b981", bg: "#f0fdf4", href: "/ListadoDevoluciones", desc: "Devoluciones de clientes", perm: "menu_devoluciones" },
  { label: "Notas de Cargo", icon: "fas fa-money-check-alt", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoNotasCargo", desc: "Notas de cargo", perm: "notasCargo" },
  { type: "section", label: "Reportes" },
  { label: "Seguimiento General", icon: "fas fa-table", color: "#6366f1", bg: "#eef2ff", href: "/SeguimientoGeneral", desc: "Compras, embarque y entrega por modelo", perm: "menu_ventas" },
  // { label: "Analisis Pedidos", icon: "fas fa-search", color: "#f59e0b", bg: "#fffbeb", href: "/AnalisisArticulosPedidos", desc: "Análisis de artículos pedidos", perm: "menu_ventas" },
  // { label: "Articulos Devoluciones", icon: "fas fa-undo-alt", color: "#8b5cf6", bg: "#f5f3ff", href: "/AnalisisArticulosDevoluciones", desc: "Análisis de devoluciones", perm: "menu_devoluciones" },
  // { label: "Reporte Surtidos", icon: "fas fa-money-check-alt", color: "#0ea5e9", bg: "#f0f9ff", href: "/ReporteSurtidos", desc: "Reporte de notas", perm: "menu_surtidos" },
  // { label: "Reporte Precios", icon: "fas fa-dollar-sign", color: "#f43f5e", bg: "#fff1f2", href: "/ReportePrecios", desc: "Reporte de precios", perm: "menu_surtidos" },
  { label: "Ultimo Precio Cliente", icon: "fas fa-dollar-sign", color: "#14b8a6", bg: "#f0fdfa", href: "/ReporteUltimoPrecio", desc: "Último precio por cliente", perm: "menu_ventas" },
  { label: "Ultimo Precio Articulo", icon: "fas fa-tshirt", color: "#6366f1", bg: "#eef2ff", href: "/ReporteUltimoPrecioArticulo", desc: "Último precio por artículo", perm: "menu_ventas" },
];

function BotonesVentas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-cash-register" color="#10b981" bg="#f0fdf4" title="Ventas" subtitle="Pedidos, surtido y clientes" />
        {user.menu_ventas ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesVentas;
